// extracted by mini-css-extract-plugin
export default {"fab":"FloatingActionButton_fab__yxqBR","visible":"FloatingActionButton_visible__+TL4U"};